import objectHandle from "../../../utilsTs/baseLib/objectHandle";
import { CommonProps, createTypeFactory, ShowPageProps } from "../../../utilsTs/declareTypes";

/** 动作对象 */
export const Actions = createTypeFactory({
    /** 提交/申请动作（触发 saga） */
    submit: { id: 'submit', name: '提交动作' },
    /** 清空数据动作（触发 saga） */
    wipe: { id: 'wipe', name: '清空数据动作' },
    /** 获取数据（仅用于 reducer 更新） */
    showPage: { id: 'showPage', name: '获取数据' },
} as const);

/** 动作string类型 */
export type ActionStringType = ReturnType<typeof Actions.getIds>[number];

/** 页面库属性 */
export interface PageStoreProps extends Pick<CommonProps, 'apiId'> {
    /** 页面缓存 */
    cache:
    Record<string, {
        /** 获取数据地址 */
        fetchUrl?: string;
        /** 返回数据是否成功 */
        success?: boolean;
        /** 数据 */
        data?: ShowPageProps;
        /** 信息 */
        message?: string;
    }>;
};


/** 提交/申请数据动作（触发 saga）*/
export const submitData = (payload: PageStoreProps) => {
    return {
        type: Actions.submit.id,
        payload,
    };
}

/** 清空数据数据动作（触发 saga） */
export const wipeData = (payload: PageStoreProps) => {
    return {
        type: Actions.wipe.id,
        payload,
    };
}

/** 获取数据（仅 reducer 使用） */
export const showPage = (payload: PageStoreProps) => {
    return {
        type: Actions.showPage.id,
        payload,
    };
}

/** 动作选项 */
interface ActionOptions {
    /** 类型 */
    type: ActionStringType;
    /** 页面 */
    payload: PageStoreProps;
}

/**
 * storeReducer
 * @param state 状态
 * @param action 动作
 * @returns 
 */
export const storeReducer = (state: PageStoreProps = {
    apiId: '',
    cache: {}
},
    action: ActionOptions) => {
    switch (action.type) {
        case 'showPage':
            return {
                ...state,
                ...action.payload,
            };
        case 'submit':
            return objectHandle.mergeObject(state, action.payload);
        case 'wipe':
            return {
                ...state,
                ...action.payload,
            };
        default: return state;
    }
}